import styled from 'styled-components';

export const POPUP_MAX_WIDTH = 948;

export const TrackingOnboardingPopupWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: ${POPUP_MAX_WIDTH}px;
  display: flex;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    background: ${({ theme }) => theme.colors.highEmphasisWhite};
    padding: ${({ theme }) => theme.spacing[10]};
    border-radius: 12px;
    height: 637px;
  }
`;
